import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Add this to your `}<inlineCode parentName="p">{`Gemfile`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`gem "posthog-ruby"
`}</code></pre>
    <p>{`In your app, set your API key `}<strong parentName="p">{`before`}</strong>{` making any calls. If setting a custom `}<inlineCode parentName="p">{`host`}</inlineCode>{`, make sure to include the protocol (e.g. `}<inlineCode parentName="p">{`https://`}</inlineCode>{`).`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`require 'posthog'

posthog = PostHog::Client.new({
  api_key: "<ph_project_api_key>",
  host: "<ph_client_api_host>",
  on_error: Proc.new { |status, msg| print msg }
})
`}</code></pre>
    <p>{`You can find your project API key and instance address in the `}<a parentName="p" {...{
        "href": "https://app.posthog.com/project/settings"
      }}>{`project settings`}</a>{` page in PostHog.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      